import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[nxTemplate]',
  host: {}
})
export class NxTemplateDirective {
  @Input() type: string | undefined;

  @Input('nxTemplate') name: string | undefined;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name!;
  }
}
